import { AUDIENCE, Audience } from "../types/audience";
import { adminAndSchoolRootUrl, customerRootUrl } from "./urls";

export const getAudienceUrl = (audience: Audience): string => {
  const portalUrl = process.env.DREAM_PORTAL_URL as string;
  if (AUDIENCE.ADMIN === audience) {
    return portalUrl + adminAndSchoolRootUrl;
  }
  if (AUDIENCE.SCHOOL === audience) {
    return portalUrl + adminAndSchoolRootUrl;
  }
  if (AUDIENCE.CUSTOMER === audience) {
    return portalUrl + customerRootUrl;
  }
  throw new Error(`Could not find URL for audience ${audience}`);
};
